/**
 * Created by karora on 2018-06-25
 *
 * Firmware routing: which firmware goes to which Hub
 */

export class FirmwareRoute {
  uid: number;
  fwsetid: number;
  comment: string;
  force: boolean;
  firmwareid: number;
  ip: string;
  hubid: number;
}
